import { useGetPromoMediaInfoQuery } from '../../../../redux/api/fymAPI';
import { PromoteMediaDraft } from '../draftStore';

interface UseMediaContainsAiVideoProps {
  accountId: number;
  /** The attached media of the Composer; undefined for a post with no media. */
  media: Pick<PromoteMediaDraft, 'fileId' | 'kind'> | undefined;
}

/**
 * True when the attached media is a video with AI-generated footage (`GET promo/media-info`). An
 * image is never AI video, so it asks nothing. False while the answer loads and when the request
 * fails: the server sets the label at the publish in every case, the notice only tells the artist.
 */
export function useMediaContainsAiVideo({ accountId, media }: UseMediaContainsAiVideoProps): boolean {
  const skip = media === undefined || media.kind === 'image';
  const query = useGetPromoMediaInfoQuery({ accountId, mediaFileId: media?.fileId ?? 0 }, { skip });
  return !skip && query.data?.containsAiVideo === true;
}
